import { ToggleButton, ToggleButtonGroup } from "@mui/material";

import { BucketTotals } from "helpers/types";

// Every bucket the summary section can show. All three carry
// single_info_cards, but Bucket 3's come from its own market value at the
// two ends of the window rather than from summed per-member report rows,
// so its income received and margin interest have no source and are absent.
export const BUCKET_KEYS = ["1", "2", "3"] as const;
export type BucketKey = (typeof BUCKET_KEYS)[number];

interface BucketToggleProps {
  value: BucketKey;
  // The report response's bucket_totals; a bucket absent from it had no
  // successful data and its option is disabled.
  bucketTotals: BucketTotals | undefined;
  onChange: (value: BucketKey) => void;
}

/** Switch for which bucket's report data to display. */
const BucketToggle = ({ value, bucketTotals, onChange }: BucketToggleProps) => (
  <ToggleButtonGroup
    size="small"
    exclusive
    value={value}
    onChange={(_, next) => next && onChange(next)}
  >
    {BUCKET_KEYS.map((key) => (
      <ToggleButton key={key} value={key} disabled={!bucketTotals?.[key]}>
        {`Bucket ${key}`}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);

export default BucketToggle;
